module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_1_m2.97632029fe030dcb035f3659169435f2.png";